import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  web: {},
  addOns: {},
  allCountries: {}
};

export default function env (state = initialState, action) {
  const { web = {}, error, type, addOns, space = {} } = action;

  switch (type) {
  case types.ENV_FETCH_REQUEST:
  case types.ENV_ADDONS_FETCH_REQUEST:
    return { ...state, isFetching: true };

  case types.ENV_FETCH_SUCCESS:
    return { ...state, web, space, isFetching: false };

  case types.ENV_ADDONS_FETCH_SUCCESS:
    return _.merge({}, state, {
      addOns,
      isFetching: false
    });

  case types.ENV_FETCH_FAILURE:
  case types.ENV_ADDONS_FETCH_FAILURE:
    return { ...state, error, isFetching: false };

  default:
    return state;
  }
}
